import React from 'react'
import PropTypes from 'prop-types'
import { SelectBankAccountCard } from '../../molecules/SelectBankAccountCard'
import { Text } from '../../atoms/text'
import { useTranslation } from '../../../context/translationProvider'
import {
  StyledAlertWrapper,
  StyledBankListWrapper,
  StyledSubheader,
  StyledTextWrapper,
} from './styles'
import { If } from '../../atoms/if'
import BasicAlert from '../../molecules/basicAlert'
import InformationIcon from '../../../images/icon_information.svg'
import WarningIcon from '../../../images/warning.svg'
import { BANK_ACCOUNT_TYPES } from '../../../utils/constants'
import { textStyles } from './styles'
import useDeviceDetect from '../../../hooks/useDeviceDetect'

export const WithdrawBankAccountList = ({
  selectedBank,
  onSelectBank,
  bankAccounts = [],
}) => {
  const { translate } = useTranslation()
  const { isMobile } = useDeviceDetect()

  const sortSalaryAccountToEnd = (a, b) => {
    if (a.defaultForWithdrawal) return -1
    if (b.defaultForWithdrawal) return 1

    if (a.accountType === BANK_ACCOUNT_TYPES.SALARY_ACCOUNT) return 1
    if (b.accountType === BANK_ACCOUNT_TYPES.SALARY_ACCOUNT) return -1

    return 0
  }

  const sortedBankAccounts = [...bankAccounts].sort(sortSalaryAccountToEnd)

  const shouldShowSalaryAccountWarning =
    selectedBank?.accountType === BANK_ACCOUNT_TYPES.SALARY_ACCOUNT

  return (
    <div>
      <StyledTextWrapper>
        <Text bold style={textStyles.title} noMargin>
          {translate('payments.withdraw.whichAccount')}
        </Text>

        <StyledSubheader
          dangerouslySetInnerHTML={{
            __html: translate('payments.withdraw.selectOneAccount'),
          }}
        />
      </StyledTextWrapper>
      <StyledBankListWrapper isMobile={isMobile}>
        {sortedBankAccounts.map((bankAccount, index) => (
          <SelectBankAccountCard
            key={index}
            bankAccount={bankAccount}
            onClick={onSelectBank}
            isChecked={selectedBank?.id === bankAccount.id}
            isDisabled={
              bankAccount?.accountType === BANK_ACCOUNT_TYPES.SALARY_ACCOUNT
            }
          />
        ))}
      </StyledBankListWrapper>
      <If
        condition={shouldShowSalaryAccountWarning}
        render={() => (
          <StyledAlertWrapper>
            <BasicAlert
              mobileIcon={WarningIcon}
              desktopIcon={InformationIcon}
              description={translate('addBankAccount.salaryAccountWarning')}
            />
          </StyledAlertWrapper>
        )}
      />
    </div>
  )
}

WithdrawBankAccountList.propTypes = {
  selectedBank: PropTypes.object,
  onSelectBank: PropTypes.func,
  bankAccounts: PropTypes.array,
}

WithdrawBankAccountList.defaultProps = {
  selectedBank: null,
  onSelectBank: () => {},
  bankAccounts: [],
}
